import React, { useEffect, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller, set } from "react-hook-form";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import toast from "react-hot-toast";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import { getSelectedOption, getSelectedOptions, localDate, localTime, showLocalDate } from "../../../_common/functions";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { useFacilityManagersSelector } from "../../../store/selectors/masterSelector";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import { AgGridReact } from "ag-grid-react";
import Label from "../../../components/elements/form/fromLabel";
import { Link } from "react-router-dom";
import CreateAssetsModal from "../../WorkRequest/_components/createAssets.modal";
import moment, { Moment } from "moment";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import Icon from "../../../components/icons";
import CreateSparePartsModal from "./createSpeareParts.modal";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import CreateCheckListsModal from "./createCheckList.modal";
import { useCycleCountApi } from "../../../store/api/hooks/cycleCountApiHook";
import Loader from "../../../components/loader";
import { useVendorsApi } from "../../../store/api/hooks/vendorsApiHook";

interface AssetsFormProps {
  _ref?: any;
  WrID?: any;
  prefillData?: any;
  editData?: any;
  onCreate?: () => void;
  onCancel?: () => void;
}

type CreateWorkOrderFormValueType = {
  workOrderID: any;
  workRequestCode: string;
  workOrderCode: string;
  workOrderStatusID: any;
  startDate: Date;
  startTime: Option | undefined;
  endDate: Date;
  endTime: Option | undefined;
  originalStartDate: Date;
  originalStartTime: Option | undefined;
  originalEndDate: Date;
  originalEndTime: Option | undefined;
  workRequestPriorityID: any;
  facilityID: Option;
  subFacilityID: any;
  description: string;
  notes: string;
  departmentID: any;
  workRequestID: any;
  assignmentTypeID: any;
  technicialID: any;
  woGrowerID: 0;
  woVendorID: 0;
  woUserMapping: [
    { userID: 0 }
  ];
  woAssetMapping: [{ assetID: 0 }];
  woSpareParts: [
    { sparePartID: 0; requiredQty: 0; facilityID: 0; subFaclityID: 0; }
  ];
  assetImage: any;
};

const CreateWorkOrder: React.FC<AssetsFormProps> = ({ _ref, WrID = null, prefillData = null, editData, onCreate = () => { }, onCancel = () => { } }) => {
  const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues } = useForm<CreateWorkOrderFormValueType>({
    defaultValues: {
      workOrderStatusID: 1,
    },
  });

  const { showLoader, hideLoader } = useAppLoader();
  const [workOrderCode, setWorkOrderCode] = useState<any>(null);
  const [facilityoption, setFacilityoption] = useState<any>(null);
  const [priority, setPriority] = useState<any>(null);
  const [statusList, setStatusList] = useState<any>(null);
  const [assigntypeList, setAssigntypeList] = useState<any>(null);
  const [departmentList, setDepartmentList] = useState<any>(null);
  const [userList, setUserList] = useState<any>(null);
  const [subfacilitylist, setsubfacilityoption] = useState<any>(null);
  const [selectedAssets, setSelectedAssets] = useState<any>([]);
  const [attachmentList, setAttachmentList] = React.useState<any[]>([]);
  const [CheckList, setCheckList] = useState<any[]>([]);
  const [workStatus, setWorkStatus] = useState<boolean>(false);
  const [partsAttachment, setPartsAttachment] = useState<any>(null);
  const [isMultiTechnicial] = useState<boolean>(true);
  const [technicianlabel] = useState<string>(`Assigned User`);
  const [deletedCheckList, setDeletedCheckList] = useState<any>([]);

  const [technicianRequired, setTechnicianRequired] = useState<boolean>(false);
  const [scheduleRequired, setScheduleRequired] = useState<boolean>(false);

  const assigntypeWatcher = watch("assignmentTypeID");
  const technicianWatcher = watch("technicialID");

  const commonApi: any = useCommonApi();
  const workOrderAPI: any = useWorkOrderApi();
  const workRequestAPI: any = useWorkRequestApi();
  const checklistAPI: any = useChecklistApi();
  const assetApi: any = useAssetsApi();
  const facilityApi: any = useFacilitiesApi();
  const cycleApi: any = useCycleCountApi();
  const vendorApi: any = useVendorsApi();

  const hasEditRun = useRef(false);
  const hasPrefillRun = useRef(false);
  const hasLoaderRun = useRef(false);

  const facilityWatch = watch("facilityID");
  const subFacilityWatch = watch("subFacilityID");

  const startdateWatch = watch("startDate");
  const starttimeWatch = watch("startTime");
  const enddateWatch = watch("endDate");
  const endtimeWatch = watch("endTime");

  const users = useFacilityManagersSelector();

  const createAssetModalRef: any = useRef();
  const createSparePartsModalRef: any = useRef();
  const createCheckListModalRef: any = useRef();

  const [rowData, setRowData] = useState<any>([]);
  const [SparePartsData, setSparePartsData] = useState<any>([]);

  const [rawEditdata, setRawEditdata] = useState<any>(null);
  const [isAssigneeMandate, setisAssigneeMandate] = useState<boolean>(false);

  const [woloader, setWoloader] = useState<boolean>(false);
  const [pendingTechnicianData, setPendingTechnicianData] = useState<any>(null);

  let imgExt = [".png", ".jpg", ".jpeg", ".webp"];

  // Generate time options in 15-minute intervals
  const generateTimeOptions = () => {
    const times: Option[] = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const time = moment().hour(hour).minute(minute).second(0).millisecond(0);
        times.push({
          label: time.format('hh:mm A'),
          value: time.format('HH:mm:ss'),
          data: time
        });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  // Function to get the nearest 15-minute interval
  const getNearestFifteenMinutes = () => {
    const now = moment();
    const minutes = now.minutes();
    const remainder = minutes % 15;
    
    let nearestTime;
    if (remainder === 0) {
      nearestTime = now;
    } else if (remainder < 8) {
      // Round down
      nearestTime = now.subtract(remainder, 'minutes').seconds(0).milliseconds(0);
    } else {
      // Round up
      nearestTime = now.add(15 - remainder, 'minutes').seconds(0).milliseconds(0);
    }
    
    // Return as option object
    const timeStr = nearestTime.format('HH:mm:ss');
    return timeOptions.find((opt: Option) => opt && opt.value === timeStr) || timeOptions[0];
  };

  // Function to add 15 minutes to a given time option
  const addFifteenMinutes = (timeOption: any) => {
    if (!timeOption) return timeOptions[0];
    const currentTime = moment(timeOption.value as string, 'HH:mm:ss');
    const newTime = currentTime.add(15, 'minutes');
    const timeStr = newTime.format('HH:mm:ss');
    return timeOptions.find((opt: Option) => opt && opt.value === timeStr) || timeOptions[0];
  };

  const getWorkCode = async () => {
    return new Promise((resolve, reject) => {
      workOrderAPI.GetWOCode({}, (resp: any) => {
        setWorkOrderCode(resp.code);
        setValue("workOrderCode", resp.code);
        resolve(resp);
      }, (error: any) => {
        toast.error(error);
      });
    });
  };

  const getfacilitylist = () => {
    const payload = {};
    facilityApi.getFacilityList(payload, (resp: any) => {
      let facilitylist: any = [];
      resp.facilityList.map((facilist: any) => {
        facilitylist.push({
          label: facilist.facilityName,
          value: facilist.facilityID,
          data: facilist,
        });
      });
      setFacilityoption(facilitylist);
    }, (error: any) => {
      console.log("error =>", error);
      setFacilityoption([]);
      toast.error(error);
    });
  };

  const getsubfacilityList = (_facilityID: any) => {
    if (editData == null) {
      setValue("workOrderStatusID", getSelectedOption(1, statusList));
    }
    const payload = { facilityID: _facilityID };
    facilityApi.getSubFacilityList(payload, (resp: any) => {
      let subfacilityoption: any = resp?.subFacilityList?.map(
        (countylist: any) => {
          return {
            label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
            value: countylist.subFacilityID,
          };
        }
      );
      setsubfacilityoption(subfacilityoption);
      if (editData) {
        const selected:any = editData.subFacilityIDs.split(',').map((subfacid: any, index: number) => {
          return {
            label: editData.subFacilityNames.split(',')[index].trim(),
            value: subfacid,
          }
        });
        setTimeout(() => {
          setValue("subFacilityID", selected);
        }, 500);
      }
      //   console.log("prefillData",prefillData);
      if (prefillData?.model?.subFacilityID) {
        // console.log("fsfdsfsfsfsfs",prefillData?.model?.subFacilityID);
        setValue(
          "subFacilityID",
          getSelectedOptions(
            prefillData?.model?.subFacilityID,
            subfacilityoption
          )
        );
      }
    }, (error: any) => {
      console.log("error =>", error);
      setsubfacilityoption([]);
      toast.error(error);
    });
  };

  const GetPriorityList = () => {
    const payload = {};
    workRequestAPI.GetPriorityList(payload, (resp: any) => {
      let facilitylist: any = [];
      resp.workRequestPriorityList.map((facilist: any) => {
        facilitylist.push({
          label: facilist.workRequestPriorityName,
          value: facilist.workRequestPriorityID,
          data: facilist,
        });
      });
      setPriority(facilitylist);
    }, (error: any) => {
      console.log("error =>", error);
      setPriority([]);
      toast.error(error);
    });
  };

  const GetStatusList = () => {
    const payload = {};
    workOrderAPI.GetWOStatusList(payload, (resp: any) => {
      let deptlist: any = [];
      resp.workOrderStatusList.map((facilist: any) => {
        deptlist.push({
          label: facilist.woStatusName,
          value: facilist.woStatusID,
        });
      });
      setStatusList(deptlist);
      //  setValue("workOrderStatusID", getSelectedOption(1, deptlist));
      setWorkStatus(true);
    }, (error: any) => {
      console.log("error =>", error);
      setStatusList([]);
      toast.error(error);
    });
  };

  const GetDepartmentList = () => {
    const payload = {pageSize: 5000,
                pageNumber: 1,};
    assetApi.getAssetdepartment(payload, (resp: any) => {
      let deptlist: any = [];
      //console.log("resp", resp);
      resp.departmentsList.map((department: any) => {
        deptlist.push({
          label: department.departmentName,
          value: department.departmentID,
        });
      });
      setDepartmentList(deptlist);
    }, (error: any) => {
      console.log("error =>", error);
      setDepartmentList([]);
      toast.error(error);
    });
  };

  const GetTechnicianList = (userType:number, facilityID?: number, callback?: (list: any[]) => void) => {
    console.log("Technician List API called", { userType, facilityID });
    const payload: any = {
      userTypeID: userType
    };
    
    if (facilityID) {
      payload.facilityID = facilityID;
    }
    
    commonApi.GetUserList(payload, (resp: any) => {
      let deptlist: any = [];
      //console.log("resp", resp);
      resp.userList?.map((user: any) => {
        deptlist.push({
          label: user.firstName + " " + user.lastName,
          value: user.userID,
        });
      });
      console.log("GetTechnicianList response", { userType, deptlist });
      setUserList(deptlist);
      if (callback) {
        callback(deptlist);
      }
    }, (error: any) => {
      console.log("error =>", error);
      setUserList([]);
      if (callback) {
        callback([]);
      }
      //toast.error(error);
    });
  };

  const GetVondorListAPI = async () => {
    return new Promise((resolve, reject) => {
      vendorApi.FilteredServiceProviderList({
        partsIDs: [],
        vendorIDs: [],
        vendorServiceTypeIDs: [],
        vendorServiceTypeExcludeIDs: [6],
        searchParam: ``,
      }, (resp: any) => {
        if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
          const deptlist = resp.vendorList.map((user: any) => {
            return { label: user.name, value: user.vendorID };
          });
          resolve(deptlist);
        } else {
          resolve([]);
        }
      }, (error: any) => {
        reject([]);
        toast.error(error);
      });
      /*
      commonApi.GetServiceprovidertList({}, (resp: any) => {
        if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
          const deptlist = resp.vendorList.map((user: any) => {
            return { label: user.name, value: user.vendorID };
          });
          resolve(deptlist);
        } else {
          resolve([]);
        }
      }, (error: any) => {
        reject([]);
        toast.error(error);
      });
      */
    });
  };

  const GetVendorList = async () => {
    const vendorresp = await GetVondorListAPI().catch((error: any) => {
      return [];
    });
    setUserList(vendorresp);
  };

  const GetAssignmentTypeList = () => {
    const payload = {};
    workOrderAPI.GetWOAssignmentTypeList(payload, (resp: any) => {
      let deptlist: any = [];
      resp.workOrderAssignmentTypeList.map((assignmentType: any) => {
        deptlist.push({ label: assignmentType.woAssignmentTypeName, value: assignmentType.woAssignmentTypeID });
      });
      setAssigntypeList(deptlist);
    }, (error: any) => {
      console.log("error =>", error);
      setAssigntypeList([]);
      toast.error(error);
    });
  };

  const getChecklists = (selectedAssets: any) => {
    let assetIDs: any = [];
    selectedAssets.map((asset: any, index: number) => {
      assetIDs.push(asset.assetID);
    });
    let payload: any = { assetIDs: assetIDs };
    checklistAPI.getChecklists(payload, (resp: any) => {
      console.log("checklist resp =>", resp.checklistList[0]);
      setCheckList(resp.checklistList.filter((clitem: any) => {
        return clitem.hasTask;
      }));
      //setRowData(resp.checklistList ? resp.checklistList : []);
      //  setTotalRecords(resp.totalRecord);
    }, (error: any) => {
      console.log("error =>", error);
      // toast.error(error);
    });
  };

  const formReset = async () => {
    if (!prefillData) {
      setAttachmentList([]);
      reset({
        startDate: undefined,
        endDate: undefined,
        startTime: undefined,
        endTime: undefined,
        description: "",
        notes: "",
        facilityID: null,
        workOrderStatusID: null,
        assetImage: "",
      });
      setTechnicianRequired(false);
      setScheduleRequired(false);
      setPendingTechnicianData(null);
      await getWorkCode().catch((error: any) => { });
      setRowData([]);
      setSelectedAssets([]);
      setCheckList([]);
      setSparePartsData([]);
    }
  };

  const reset_re_render_vars = () => {
    hasPrefillRun.current = false;
    hasEditRun.current = false;
    hasLoaderRun.current = false;
    setWoloader(false);
  };

  const changeAttachmentHandler = (e: any) => {
    setPartsAttachment(e.target.files);
  };

  const onSubmit: SubmitHandler<CreateWorkOrderFormValueType> = async (data: any) => {
    //  const AssData = selectedAssets.map((node: any) => node.assetID);
    var payload: any = {
      workOrderID: null,
      workRequestID: null,
      workOrderCode: null,
      workOrderStatusID: null,
      startDate: null,
      originalStartDate: null,
      endDate: null,
      originalEndDate: null,
      workRequestPriorityID: null,
      facilityID: null,
      subFacilityID: null,
      description: null,
      notes: null,
      assignmentTypeID: null,
      departmentID: null,
      woGrowerID: null,
      woVendorID: null,
      maintainanceTypeID: null,
      woAssetMapping: [],
      woUserMapping: [],
      woSpareParts: [],
    };
    console.log("Work Request ID is ->", WrID);
    if (WrID) {
      payload.workRequestID = WrID;
    }

    for (const index in Object.keys(payload)) {
      var key = Object.keys(payload)[index];
      console.log(key, data[key]);
      if (key in data) {
        payload[key] = data[key];
      }
    }
    const buildWoUserMapping = (technicians: any) => {
      if (!technicians) return [];
      const technicianArr = Array.isArray(technicians) ? technicians : [technicians];
      return technicianArr.map((item: any) => ({ userID: item.value }));
    };
    const firstTechnician = Array.isArray(data.technicialID)
      ? data.technicialID[0]
      : data.technicialID;
    if (data.assignmentTypeID && typeof data.assignmentTypeID === "object") {
      payload.woUserMapping = buildWoUserMapping(data.technicialID);
      switch (data.assignmentTypeID.value.toString()) {
        case "1": {
          payload.woVendorID = null;
          payload.woGrowerID = null;
          break;
        }
        case "2": {
          payload.woGrowerID = firstTechnician?.value ?? null;
          payload.woVendorID = null;
          break;
        }
        case "3": {
          payload.woVendorID = firstTechnician?.value ?? null;
          payload.woGrowerID = null;
          break;
        }
      }
      payload.assignmentTypeID = data.assignmentTypeID.value;
    }
    if (data.departmentID && typeof data.departmentID === "object") {
      payload.departmentID = data.departmentID.value;
    }
    if (data.facilityID && typeof data.facilityID === "object") {
      payload.facilityID = data.facilityID.value;
    }
    if (data.subFacilityID && typeof data.subFacilityID === "object") {
      payload.subFacilityIDs = data.subFacilityID.map((subfac: any) => subfac.value);
    } else {
      payload.subFacilityIDs = null;
    }
    if (data.workRequestPriorityID && typeof data.workRequestPriorityID === "object") {
      payload.workRequestPriorityID = data.workRequestPriorityID.value;
    }
    if (data.workOrderStatusID && typeof data.workOrderStatusID === "object") {
      payload.workOrderStatusID = data.workOrderStatusID.value;
    }
    if (data.startDate && data.startTime) {
      const timeValue = typeof data.startTime === "object" && data.startTime.value ? data.startTime.value : data.startTime;
      payload.startDate = moment(moment(data.startDate).format(`YYYY-MM-DD`) + " " + timeValue, `YYYY-MM-DD HH:mm:ss`).utc().toISOString();
    }
    if (data.endDate && data.endTime) {
      const timeValue = typeof data.endTime === "object" && data.endTime.value ? data.endTime.value : data.endTime;
      payload.endDate = moment(moment(data.endDate).format(`YYYY-MM-DD`) + " " + timeValue, `YYYY-MM-DD HH:mm:ss`).utc().toISOString();
    }
    if (data.originalStartDate && data.originalStartTime) {
      const timeValue = typeof data.originalStartTime === "object" && data.originalStartTime.value ? data.originalStartTime.value : data.originalStartTime;
      payload.originalStartDate = moment(moment(data.originalStartDate).format(`YYYY-MM-DD`) + " " + timeValue, `YYYY-MM-DD HH:mm:ss`).utc().toISOString();
    }
    if (data.originalEndDate && data.originalEndTime) {
      const timeValue = typeof data.originalEndTime === "object" && data.originalEndTime.value ? data.originalEndTime.value : data.originalEndTime;
      payload.originalEndDate = moment(moment(data.originalEndDate).format(`YYYY-MM-DD`) + " " + timeValue, `YYYY-MM-DD HH:mm:ss`).utc().toISOString();
    }
    if (payload.startDate && payload.endDate && moment.utc(payload.endDate).diff(moment.utc(payload.startDate), "minutes") < 1) {
      return toast.error("End date and time must be greater than start date and time.");
    }
    /* if (rowData.length === 0) {
      return toast.error("Please add at least one asset to the Task.");
    } */

    const AssData = rowData?.map((item: any) => {
      return { assetID: item.assetID };
    });

    const partsData = SparePartsData?.map((itemSpare: any) => {
      return {
        sparePartID: itemSpare.partsID,
        requiredQty: itemSpare.requiredQty ? itemSpare.requiredQty : 0,
        facilityID: 0,
        subFaclityID: 0,
      };
    });
    payload.woAssetMapping = AssData;
    payload.woSpareParts = partsData;
    payload.workOrderCode = workOrderCode;
    payload.workOrderID = editData ? editData?.workOrderID : null;
    if (rawEditdata && rawEditdata.workRequestID) {
      payload.workRequestID = rawEditdata.workRequestID;
    }

    console.log("data is -> ", data);
    console.log("payload is-> ", payload);

    //return false;
    if (data.hasOwnProperty(`startDate`) && typeof data.startDate == "undefined") {
      payload.startDate = null;
    }
    if (data.hasOwnProperty(`endDate`) && typeof data.endDate == "undefined") {
      payload.endDate = null;
    }
    showLoader();
    console.log("Submit data To workorder", payload, editData);
    workOrderAPI.SaveWorkOrder(payload, async (resp: any) => {
      let payloadChecklist: any = {};
      if (CheckList) {
        let taskListarray: any = [];
        await new Promise((resolve, reject) => {
          payloadChecklist.workOrderID = editData ? editData?.workOrderID : resp?.returnID;
          CheckList.map((checklist: any, index: number) => {
            taskListarray.push(checklist.checkListID);
          });
          payloadChecklist.checkLists = taskListarray;
          workOrderAPI.SaveWorkOrderTaskDetails(payloadChecklist, (resp: any) => {
            resolve(resp);
          }, (error: any) => {
            reject(error);
          });
        }).catch((error: any) => {
          return null;
        });
      }
      const formData = new FormData();
      formData.append("workOrderID", editData ? editData?.workOrderID : resp?.returnID);
      if (partsAttachment) {
        var i = 0;
        for await (const partattchment of partsAttachment) {
          formData.append("InputFile" + i, partsAttachment[i]);
          i++;
        }
        const uploadresp: any = await new Promise((resolve, reject) => {
          workOrderAPI.UploadImage(formData, (resp: any) => {
            resolve(resp);
          }, (error: any) => {
            toast.error(error);
            reject(error);
          });
        }).catch((error: any) => { });
        if (uploadresp) {
          toast.success(uploadresp?.message);
        }
      } else {
        formReset();
      }
      if (resp && resp?.successful && resp.successful) {
        toast.success(resp?.message);
      } else {
        toast.error(resp?.message);
      }

      onCreate();
      reset_re_render_vars();
      formReset();
      hideLoader();
      console.log(resp, "Submited resp");
    }, (error: any) => {
      console.log("error =>", error);
      toast.error(error);
      hideLoader();
    });
    console.log("Submit payload", payload);
  };

  const init_page_date = async () => {
    await getWorkCode().catch((error: any) => { });
    getfacilitylist();
    GetPriorityList();
    GetStatusList();
    GetDepartmentList();
    GetAssignmentTypeList();
    // Load technician list by default for edit mode
    GetTechnicianList(1); // default load using first assignment type
  };

  useEffect(() => {
    setWoloader(true);
    init_page_date();
  }, []);

  useEffect(() => {
    if (hasEditRun.current || (!editData)) {
      if (assigntypeWatcher && technicianWatcher && startdateWatch && starttimeWatch && enddateWatch && endtimeWatch) {
        setValue(`workOrderStatusID`, getSelectedOption(2, statusList));
      } else if (assigntypeWatcher && technicianWatcher && !(startdateWatch && starttimeWatch && enddateWatch && endtimeWatch)) {
        setValue(`workOrderStatusID`, getSelectedOption(7, statusList));
      } else {
        setValue(`workOrderStatusID`, getSelectedOption(1, statusList));
      }
    }
  }, [assigntypeWatcher, technicianWatcher, startdateWatch, starttimeWatch, enddateWatch, endtimeWatch]);

  useEffect(() => {
    if (facilityWatch) {
      setValue("subFacilityID", null);
      getsubfacilityList(facilityWatch.value);
      //console.log("fsfsfsf wwww",facilityWatch?.data?.latitude);
    }
  }, [facilityWatch]);

  useEffect(() => {
    if (startdateWatch || starttimeWatch || enddateWatch || endtimeWatch) {
      setisAssigneeMandate(true);
    } else {
      setisAssigneeMandate(false);
    }
  }, [startdateWatch, starttimeWatch, enddateWatch, endtimeWatch]);

  // Auto-update end time when start time changes (only for new work orders)
  useEffect(() => {
    if (!editData && starttimeWatch && !hasEditRun.current) {
      const newEndTime = addFifteenMinutes(starttimeWatch);
      setValue("endTime", newEndTime);
    }
  }, [starttimeWatch]);

  // Auto-update end date when start date changes (only for new work orders)
  useEffect(() => {
    if (!editData && startdateWatch && !hasEditRun.current) {
      setValue("endDate", startdateWatch);
    }
  }, [startdateWatch]);

  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reset = formReset;
      _ref.current.reset_re_render_vars = reset_re_render_vars;
      _ref.current.getValues = getValues;
      _ref.current.setValue = setValue;
    }
  }, [_ref]);

  useEffect(() => {
    if (editData == null && !prefillData) {
      formReset();
    }
  }, [editData]);

  useEffect(() => {
    if (facilityoption && users && statusList && priority && assigntypeList && departmentList && !hasLoaderRun.current) {
      setWoloader(false);
      hasLoaderRun.current = true;
    }
  }, [facilityoption, users, statusList, priority, assigntypeList, departmentList]);

  useEffect(() => {
    if (editData && !prefillData && facilityoption && users && statusList && priority && assigntypeList && departmentList && !hasEditRun.current) {
      console.log("editData useEffect triggered", {
        editData,
        facilityoption: !!facilityoption,
        users: !!users,
        statusList: !!statusList,
        priority: !!priority,
        assigntypeList: !!assigntypeList,
        userList: !!userList,
        departmentList: !!departmentList,
        hasEditRun: hasEditRun.current
      });
      setWoloader(true);
      const payload = { WorkOrderID: editData.workOrderID };
      workOrderAPI.GetWorkOrderByID(payload, async (resp: any) => {
        console.log("Edit data resp", resp);
        if (resp && resp.hasOwnProperty(`workOrderID`) && resp.workOrderID) {
          setRawEditdata(resp);
          //Set Existing Task Code in edit mode.
          setWorkOrderCode(resp.workOrderCode);
          setValue("workOrderCode", resp.workOrderCode);

          // Task details Spare part available stock count fetch -  Start
          if (resp && resp.hasOwnProperty(`workOrderPartsMappingList`) && Array.isArray(resp.workOrderPartsMappingList) && resp.workOrderPartsMappingList.length > 0) {
            for await (const part of resp.workOrderPartsMappingList) {
              part[`currenctStock`] = 0;
              const prespitem: any = await new Promise((resolve, reject) => {
                cycleApi.GetStockCount({ partID: part.partsID, facilityID: editData.facilityID }, (presp: any) => {
                  resolve(presp);
                }, (error: any) => {
                  console.log("Parts stock error -> " + part.sparePartsName + " -> ", error);
                  reject(null);
                });
              }).catch((error: any) => {
                return null;
              });
              if (prespitem && prespitem.hasOwnProperty(`currentStock`) && +prespitem.currentStock >= 0) {
                part[`currenctStock`] = prespitem.currentStock;
              }
            }
          }
          // Task details Spare part available stock count fetch -  End

          setRowData(resp.workOrderAssetMappingList);
          setSparePartsData(resp.workOrderPartsMappingList || []);
          
          // Convert time from moment to option format
          const startTimeMoment = localTime(resp.startDate);
          const endTimeMoment = localTime(resp.endDate);
          const startTimeOption = startTimeMoment ? timeOptions.find((opt: Option) => opt && opt.value === startTimeMoment.format('HH:mm:ss')) : undefined;
          const endTimeOption = endTimeMoment ? timeOptions.find((opt: Option) => opt && opt.value === endTimeMoment.format('HH:mm:ss')) : undefined;
          
          const editflldata: any = {
            description: editData?.description,
            notes: editData?.notes,
            facilityID: getSelectedOption(editData.facilityID, facilityoption),
            workOrderStatusID: getSelectedOption(editData?.woStatusID, statusList),
            workRequestPriorityID: getSelectedOption(resp?.priorityID, priority),
            assignmentTypeID: getSelectedOption(resp?.woAssignmentTypeID, assigntypeList),
            departmentID: getSelectedOption(resp?.departmentID, departmentList),
            startDate: localDate(resp.startDate),
            endDate: localDate(resp.endDate),
            startTime: startTimeOption,
            endTime: endTimeOption,
          };
          setValue("workOrderStatusID", getSelectedOption(2, statusList));
          var attachmentlistx_total: any = [];
          const woimagesresp = await new Promise((resolve, rejects) => {
            workOrderAPI.GetWorkOrderImages(payload, (resp: any) => {
              //console.log("resp===========?", resp);
              //const attachmentList = resp?.files ? resp?.files : [];
              //setAttachmentList(attachmentList);
              resolve(resp?.files ? resp?.files : []);
            }, (error: any) => {
              rejects([]);
            });
          }).catch((error: any) => {
            return [];
          });
          attachmentlistx_total = woimagesresp;
          if (resp.hasOwnProperty(`workRequestID`) && typeof resp.workRequestID !== `undefined` && resp.workRequestID) {
            editflldata.workRequestID = resp.workRequestID;
            const wrimagesresp = await new Promise((resolve, rejects) => {
              workRequestAPI.GetWorkRequestImages({ workRequestID: resp.workRequestID }, (resp: any) => {
                resolve(resp && resp?.files ? resp?.files : []);
              }, (error: any) => {
                rejects([]);
              });
            }).catch((error: any) => { });
            attachmentlistx_total = attachmentlistx_total.concat(wrimagesresp);
          }
          console.log("attachmentlistx_total", attachmentlistx_total);
          console.log("During edit flldata", editflldata);
          setAttachmentList(attachmentlistx_total);
          
          // Load technician/vendor list first, then reset form with all data including technician selection
          const loadAndSetTechnicians = async () => {
            if (resp?.woAssignmentTypeID == 2) {
              // For grower
              const growerID = resp?.woGrowerID;
              console.log("Loading grower for edit mode", { growerID, facilityID: editData?.facilityID });
              
              await new Promise<void>((resolve) => {
                GetTechnicianList(resp?.woAssignmentTypeID, editData?.facilityID ? Number(editData.facilityID) : undefined, (growerList) => {
                  console.log("Grower list loaded", { growerList, growerID });
                  if (growerID && growerList && growerList.length > 0) {
                    const selectedGrower = getSelectedOption(growerID, growerList);
                    console.log("Setting grower value", selectedGrower);
                    editflldata.technicialID = selectedGrower ? [selectedGrower] : [];
                  }
                  resolve();
                });
              });
            }
            else if (resp?.woAssignmentTypeID == 3) {
              // Load vendor list using assignment type value
              const vendorID = resp?.woVendorID;
              console.log("Loading vendor for edit mode", { vendorID, facilityID: editData?.facilityID });
              
              await new Promise<void>((resolve) => {
                GetTechnicianList(resp?.woAssignmentTypeID, editData?.facilityID ? Number(editData.facilityID) : undefined, (vendorList) => {
                  console.log("Vendor list loaded", { vendorList, vendorID });
                  if (vendorID && vendorList && vendorList.length > 0) {
                    const selectedVendor = getSelectedOption(vendorID, vendorList);
                    console.log("Setting vendor value", selectedVendor);
                    editflldata.technicialID = selectedVendor ? [selectedVendor] : [];
                  }
                  resolve();
                });
              });
            }
            else {
              // For all other assignment types (1 = Internal, 5 = Accounting, etc.)
              // Check if workOrderUserMappingList exists
              if (resp && resp.hasOwnProperty(`workOrderUserMappingList`) && Array.isArray(resp.workOrderUserMappingList) && resp.workOrderUserMappingList.length > 0) {
                const userIDs = resp.workOrderUserMappingList.map((o: any) => o.userID);
                console.log("Loading users for edit mode", { assignmentType: resp?.woAssignmentTypeID, userIDs, facilityID: editData?.facilityID });
                
                await new Promise<void>((resolve) => {
                  GetTechnicianList(resp?.woAssignmentTypeID, editData?.facilityID ? Number(editData.facilityID) : undefined, (userList) => {
                    console.log("User list loaded", { userList, userIDs });
                    if (userIDs && userIDs.length > 0 && userList && userList.length > 0) {
                      const selectedUsers = getSelectedOptions(userIDs, userList);
                      console.log("Setting user values", selectedUsers);
                      editflldata.technicialID = selectedUsers;
                    }
                    resolve();
                  });
                });
              } else {
                // No users to set, just load the list
                GetTechnicianList(resp?.woAssignmentTypeID, editData?.facilityID ? Number(editData.facilityID) : undefined);
              }
            }
          };
          
          await loadAndSetTechnicians();
          console.log("Final edit flldata with technicians", editflldata);
          reset(editflldata);
        }
        hasEditRun.current = true;
        const wotaskresp = await new Promise((resolve, reject) => {
          workOrderAPI.GetWOTasks(payload, (resp: any) => {
            console.log("resp===========?", resp);
            let uniqueTasks: any = [];
            let seenCheckListIDs = new Set();
            // Filter tasks by checkListID and ensure uniqueness
            resp?.tasks.forEach((task: any) => {
              if (!seenCheckListIDs.has(task.checkListID)) {
                seenCheckListIDs.add(task.checkListID);
                task.title = task.checkListTitle;
                uniqueTasks.push(task);
              }
            });
            setCheckList(uniqueTasks);
            resolve(uniqueTasks);
          }, (error: any) => {
            resolve([]);
          });
        }).catch((error: any) => {
          return null;
        });
        setWoloader(false);
      }, (error: any) => {
        hasEditRun.current = true;
        setWoloader(false);
      });
    } else {
      if (!prefillData) {
        //formReset();
      }
    }
  }, [editData, facilityoption, users, statusList, priority, assigntypeList, departmentList]);


  useEffect(() => {
    if (prefillData && facilityoption && users && statusList && priority && assigntypeList && departmentList && !hasPrefillRun.current) {
      setWoloader(true);
      console.log("Prefill data is ->", prefillData);
      setValue("workRequestID", prefillData?.model?.workRequestID);
      setValue("workOrderStatusID", getSelectedOption(1, statusList));
      setValue("description", prefillData?.model?.description);
      setValue("facilityID", getSelectedOption(prefillData?.model?.facilityID, facilityoption));
      setValue("workRequestPriorityID", getSelectedOption(prefillData?.model?.workRequestPriorityID, priority));
      setRowData(prefillData?.assets || []);
      setCheckList(prefillData?.checklist || []);
      setAttachmentList(prefillData?.images || []);
      hasPrefillRun.current = true;
      setWoloader(false);
    }
  }, [prefillData, facilityoption, users, statusList, priority, assigntypeList, departmentList]);

  return (
    <div className={`relative`}>
      {woloader && (
        <div className={`absolute p-8`} style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
          <Loader />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={`${woloader ? `hidden` : `flex`} flex-col`}>
        <div className="flex-1 overflow-auto">
          <h4 className="font-semibold text-[0.938rem] border-gray-200 py-4 uppercase">General</h4>
          {workOrderCode && (
            <div className="bg-green-50 py-2 px-3">
              <h6 className="text-[0.813rem] font-semibold">Task Number</h6>
              <p className="text-[0.813rem] font-normal mt-2">{workOrderCode}</p>
            </div>
          )}

          <div className={`h-[0.5rem]`}></div>

          <Controller
            name="workOrderStatusID"
            control={control}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Status"
                value={value}
                onChange={onChange}
                disabled={workStatus}
                placeholder="Choose Status"
                className="mt-0"
                options={statusList ? statusList : []}
                error={errors.workOrderStatusID?.message as any}
              />
            )}
          />
          <div className="grid grid-cols-2 gap-2 relative">
            <Controller
              name="startDate"
              control={control}
              render={({ field: { value, onChange } }) => (
                <Datepicker
                  label="Schedule Start Date"
                  minDate={new Date()}
                  value={value}
                  onChange={onChange}
                  error={errors.startDate?.message}
                />
              )}
            />
            <Controller
              name="startTime"
              // rules={{ required: scheduleRequired ? "Schedule Start Time is required" : false }}
              // rules={{ required: "Plan Start Time is required" }}
              control={control}
              render={({ field: { value, onChange } }) => (
                <SelectBox
                  label="Schedule Start Time"
                  value={value}
                  onChange={onChange}
                  placeholder="Select Time"
                  options={timeOptions}
                  error={errors.startTime?.message as any}
                />
              )}
            />
          </div>
          <div className="grid grid-cols-2 gap-2 relative">
            <Controller
              name="endDate"
              control={control}
              // rules={{ required: scheduleRequired ? "Schedule End Date is required" : false }}
              // rules={{ required: "Plan End Date is required" }}
              render={({ field: { value, onChange } }) => (
                <Datepicker
                  label="Schedule End Date"
                  //required={scheduleRequired}
                  minDate={watch("startDate") || new Date()}
                  value={value}
                  onChange={onChange}
                  error={errors.endDate?.message}
                />
              )}
            />
            <Controller
              name="endTime"
              // rules={{ required: scheduleRequired ? "Schedule End Time is required" : false }}
              // rules={{ required: "Plan End Time is required" }}
              control={control}
              render={({ field: { value, onChange } }) => (
                <SelectBox
                  label="Schedule End Time"
                  value={value}
                  onChange={onChange}
                  placeholder="Select Time"
                  options={timeOptions}
                  // required={scheduleRequired}
                  error={errors.endTime?.message as any}
                />
              )}
            />
          </div>

          <Controller
            name="workRequestPriorityID"
            control={control}
            rules={{ required: "Priority is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Priority"
                value={value}
                onChange={onChange}
                required
                placeholder="Choose Priority"
                options={priority ? priority : []}
                error={errors.workRequestPriorityID?.message as any}
              />
            )}
          />

          <Controller
            name="facilityID"
            control={control}
            rules={{ required: "Facility is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Select Facility"
                required
                value={value}
                onChange={(SelectOption: any) => {
                  if (SelectOption.value != facilityWatch?.value) {
                    onChange(SelectOption);
                    setValue("subFacilityID", null);
                    setsubfacilityoption([]);
                    setCheckList([]);
                    setSparePartsData([]);
                    setRowData([]);
                    getsubfacilityList(SelectOption.value);
                  }
                }}
                //   required
                placeholder="Choose Facility"
                options={facilityoption ? facilityoption : []}
                error={errors.facilityID?.message as any}
              />
            )}
          />

          <Controller
            name="subFacilityID"
            control={control}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Select Sub Facility"
                onChange={onChange}
                value={value}
                isMulti={true}
                placeholder="Choose Sub Facility"
                options={subfacilitylist ? subfacilitylist : []}
                error={errors.subFacilityID?.message as any}
              />
            )}
          />

          <Controller
            name="description"
            rules={{ required: "Description is required" }}
            control={control}
            render={({ field: { value, onChange } }) => (
              <Teaxtarea
                label="Description"
                value={value}
                onChange={onChange}
                required
                placeholder=""
                error={errors.description?.message}
              />
            )}
          />

          <Controller
            name="notes"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Teaxtarea
                label="Notes"
                value={value}
                onChange={onChange}
                placeholder="Possible root cause, spare parts needed, special tools required"
              />
            )}
          />

          <div className="flex justify-between mb-1 my-6 mx-4 pb-42 ml-0">
            <Label text={"ASSIGNEE"} isBold={true} />
          </div>

          <Controller
            name="assignmentTypeID"
            control={control}
            rules={{ required: isAssigneeMandate ? "Facility is required" : false }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Assignment Type"
                value={value}
                required={isAssigneeMandate}
                onChange={(SelectOption: any) => {
                  onChange(SelectOption);
                  setTechnicianRequired(true);
                  //setScheduleRequired(true);

                  if (SelectOption) {
                    GetTechnicianList(
                      SelectOption.value,
                      facilityWatch?.value ? Number(facilityWatch.value) : undefined
                    );
                  }
                  setValue("technicialID", []);
                  /*
                  if (SelectOption?.value !== 1) {
                    setValue("technicialID", null);
                  }
                  */
                }}
                //   required
                placeholder="Assignment Type"
                options={assigntypeList ? assigntypeList : []}
                error={errors.assignmentTypeID?.message as any}
              />
            )}
          />

          <Controller
            name="technicialID"
            control={control}
            rules={{
              required: technicianRequired ? `This field is required.` : false,
            }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label={technicianlabel}
                isMulti={isMultiTechnicial}
                value={value}
                onChange={onChange}
                required={technicianRequired}
                placeholder="Select Option"
                options={userList ? userList : []}
                error={errors.technicialID?.message as any}
              />
            )}
          />

          <Controller
            name="departmentID"
            control={control}
            rules={{ required: "Department is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Department"
                value={value}
                onChange={onChange}
                required
                placeholder="Select"
                options={departmentList ? departmentList : []}
                error={errors.departmentID?.message as any}
              />
            )}
          />

          <div>
            <div className="flex justify-between mb-2 my-6 mx-4 pb-4 ml-0">
              <Label text={"ASSETS"} isBold={true} />
              <p className="cursor-pointer text-[0.938rem] text-primary  font-normal" onClick={() => {
                if (facilityWatch) {
                  createAssetModalRef?.current?.showModal();
                } else {
                  toast.error("Please select facility");
                }
              }}>
                Add New Assets
              </p>
            </div>

            <div className={`custom-static-grid`}>
              <div className={`custom-static-table`} style={{ border: `1px solid #043E6133`, borderRadius: `5px`, overflow: `hidden` }}>
                <div className={`flex items-center bg-[#f0f0f0]`} style={{ height: `52px` }}>
                  <div className={`px-2 py-4 font-medium text-center`} style={{ fontSize: `13px`, color: `#262A2D`, width: `150px` }}>Asset ID</div>
                  <div className={`flex-grow px-2 py-4 font-medium`} style={{ fontSize: `13px`, color: `#262A2D` }}>Asset Name</div>
                  <div className={`px-2 py-4 font-medium`} style={{ fontSize: `13px`, color: `#262A2D`, width: `130px` }}>Last Maintenance Date</div>
                  <div className={`px-2 py-4 font-medium`} style={{ fontSize: `13px`, color: `#262A2D`, width: `115px` }}>Warranty Expiry Date</div>
                  <div className={`px-2 py-4 text-right`} style={{ textAlign: `right`, width: `42px` }}></div>
                </div>

                {rowData && rowData.map((asset: any, index: number) => {
                  return (
                    <div className={`flex items-center`} style={{ borderBottom: `1px solid #043E6133` }}>
                      <div className={`px-2 py-2 text-center font-light`} style={{ width: `150px` }}>{asset.assetCode}</div>
                      <div className={`px-2 py-2 flex-grow font-light`}>{asset.name}</div>
                      <div className={`px-2 py-2 font-light`} style={{ width: `130px` }}>{asset.vehicleLastInspection ? moment.utc(asset.vehicleLastInspection).local().format(`MM/DD/YY`) : `-`}</div>
                      <div className={`px-2 py-2 text-center font-light`} style={{ width: `115px` }}>{asset.warrantyEndDate ? moment.utc(asset.warrantyEndDate).local().format(`MM/DD/YY`) : `-`}</div>
                      <div className={`px-2 py-4 text-right`} style={{ textAlign: `right`, width: `42px` }}>
                        <a className={`text-primary`} onClick={() => {
                          if (SparePartsData && SparePartsData.length > 0) {
                            toast.error("Please remove all spare parts first before removing this asset.");
                            return;
                          }
                          if (window.confirm("Are you sure you want to remove this asset?")) {
                            rowData.splice(index, 1);
                            setRowData([...rowData]);
                          }
                        }}>
                          <Icon name="cross" size={1} />
                        </a>
                      </div>
                    </div>
                  );
                })}
                {rowData?.length === 0 && (
                  <div className={`flex items-center justify-center`} style={{ height: `200px`, color: `#262A2D` }}>
                    <p>No assets added yet!</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={`mb-8`}>
            <div className="flex justify-between  mb-2 my-6 mx-4 pb-4  ml-0">
              <Label text={"SPARE PARTS"} isBold={true} />
              <p className="cursor-pointer text-[0.938rem] text-primary  font-normal" onClick={() => {
                if (rowData && rowData.length > 0) {
                  createSparePartsModalRef?.current?.showModal();
                } else {
                  toast.error("Please add assets first");
                }
              }}>
                Add New Spare Parts
              </p>
            </div>
            <div className={`custom-static-grid`}>
              <div className={`custom-static-table`} style={{ border: `1px solid #043E6133`, borderRadius: `5px`, maxWidth: `673px`, overflow: `hidden` }}>
                <div className={`flex items-center bg-[#f0f0f0]`} style={{ height: `52px` }}>
                  <div className={`px-2 py-4 font-medium text-center`} style={{ fontSize: `13px`, color: `#262A2D`, width: `140px`, minWidth: `140px` }}>Part Code</div>
                  <div className={`flex-grow px-2 py-4 font-medium`} style={{ fontSize: `13px`, color: `#262A2D`, width: `calc(100% - 407px)` }}>Part Name</div>
                  <div className={`px-2 py-4 font-medium text-center`} style={{ fontSize: `13px`, color: `#262A2D`, width: `110px` }}>Availble QTY</div>
                  <div className={`px-2 py-4 font-medium`} style={{ fontSize: `13px`, color: `#262A2D`, width: `115px` }}>Required QTY</div>
                  <div className={`px-2 py-4 text-right`} style={{ textAlign: `right`, width: `42px` }}></div>
                </div>
                {SparePartsData && SparePartsData.map((parts: any, index: number) => {
                  return (
                    <div className={`flex items-center`} style={{ borderBottom: `1px solid #043E6133` }}>
                      <div className={`px-2 py-2 text-center font-light`} style={{ width: `140px`, minWidth: `140px` }}>{parts.partsCode}</div>
                      <div className={`px-2 py-2 flex-grow font-light`} style={{ width: `calc(100% - 407px)`, whiteSpace: `nowrap`, overflow: `hidden`, textOverflow: `ellipsis` }}>{parts.sparePartsName}</div>
                      <div className={`px-2 py-2 text-center font-light`} style={{ width: `110px` }}>{Number(parts.currenctStock)}</div>
                      <div className={`font-normal px-2 py-2 text-center`} style={{ width: `115px` }}>
                        <input
                          type="text"
                          placeholder="Enter qty"
                          className={`border-[#CECECE] border rounded-md focus:outline-none focus:primary text-[0.938rem] px-2 py-1  font-normal h-[2rem] text-[#222222] placeholder:text-[#a1a1a1] w-full text-center`}
                          value={parts.requiredQty || ""}
                          onChange={(e: any) => {
                            setSparePartsData(
                              SparePartsData.map((partsc: any, j: number) => {
                                if (index == j) {
                                  partsc.requiredQty = e.target.value;
                                }
                                return partsc;
                              })
                            );
                          }}
                        />
                      </div>
                      <div className={`px-2 py-4 text-right`} style={{ textAlign: `right`, width: `42px` }}>
                        <a className={`text-primary`} onClick={() => {
                          if (window.confirm("Are you sure you want to remove this asset?")) {
                            SparePartsData.splice(index, 1);
                            setSparePartsData([...SparePartsData]);
                          }
                        }}>
                          <Icon name="cross" size={1} />
                        </a>
                      </div>
                    </div>
                  );
                })}
                {!SparePartsData || (SparePartsData && SparePartsData.length < 1 && (
                  <div className={`flex items-center justify-center`} style={{ height: `200px`, color: `#262A2D` }}>
                    <p>No spare parts added yet!</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div>
            <div className="flex justify-between mb-2 my-6 mx-4 pb-4 ml-0">
              <Label text={"Checklist"} isBold={true} />
              <p className="cursor-pointer text-[0.938rem] text-primary  font-normal" onClick={() => {
                //if (facilityWatch) {
                  createCheckListModalRef?.current?.showModal();
                  //console.log(findAssetsNewModalRef?.current);
                  //  findAssetsNewModalRef?.current?.show();
                  //setIsOpenAssetModal(true);
                  //findAssetsModalRef?.current?.showModal();
                /* } else {
                  toast.error("Please select facility");
                } */
              }}>
                Add New Checklist
              </p>
            </div>

            <div className={`custom-static-grid`}>
              <div className={`custom-static-table`} style={{ border: `1px solid #043E6133`, borderRadius: `5px`, overflow: `hidden` }}>
                <div className={`flex items-center bg-[#f0f0f0]`} style={{ height: `52px` }}>
                  <div className={`px-2 py-4 font-medium text-center`} style={{ fontSize: `13px`, color: `#262A2D`, width: `128px` }} >Checklist No</div>
                  <div className={`flex-grow px-2 py-4 font-medium`} style={{ fontSize: `13px`, color: `#262A2D` }}>Title</div>
                  <div className={`px-2 py-4 text-right`} style={{ textAlign: `right`, width: `42px` }}></div>
                </div>

                {CheckList && CheckList.map((checklist: any, index: number) => {
                  return (
                    <div key={checklist.assetCode} className={`flex items-center`} style={{ borderBottom: `1px solid #043E6133` }}>
                      <div className={`px-2 py-2 text-center font-light`} style={{ width: `128px`, whiteSpace: `nowrap`, overflow: `hidden`, textOverflow: `ellipsis` }}>{checklist.checkListCode}</div>
                      <div className={`px-2 py-2 flex-grow font-light`}>{checklist.title}</div>
                      <div className={`px-2 py-4 text-right`} style={{ textAlign: `right`, width: `42px` }}>
                        <a href="javascript:void(0);" className={`text-primary`} onClick={() => {
                          if (window.confirm("Are you sure you want to remove this Checklist?")) {
                            setDeletedCheckList([
                              ...deletedCheckList,
                              checklist.checkListID,
                            ]);
                            CheckList.splice(index, 1);
                            setCheckList([...CheckList]);
                          }
                        }}>
                          <Icon name="cross" size={1} />
                        </a>
                      </div>
                    </div>
                  );
                })}
                {CheckList.length === 0 && (
                  <div className={`flex items-center justify-center`} style={{ height: `200px`, color: `#262A2D` }}>
                    <p>No Checklist added yet!</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <CreateSparePartsModal
            _ref={createSparePartsModalRef}
            facility={facilityWatch}
            subFacility={subFacilityWatch}
            onContinue={async (selectedSpareparts: any[]) => {
              console.log("Selected Spare Parts", selectedSpareparts);
              createSparePartsModalRef?.current?.close();
              /*
              showLoader();
              if (Array.isArray(selectedSpareparts) && selectedSpareparts.length > 0) {
                for await (const part of selectedSpareparts) {
                  part[`currenctStock`] = 0;
                  const prespitem:any = await new Promise((resolve, reject) => {
                    cycleApi.GetStockCount({ partID: part.partsID, facilityID: part.facilityID }, (presp:any) => {
                      resolve(presp);
                    }, (error:any) => {
                      console.log("Parts stock error -> " + part.sparePartsName + " -> ", error);
                      reject(null);
                    });
                  }).catch((error:any) => {
                    return null;
                  });
                  if (prespitem && prespitem.hasOwnProperty(`currentStock`) && +prespitem.currentStock >=0) {
                    part[`currenctStock`] = prespitem.currentStock;
                  }              
                }            
              }
              hideLoader();
              */
              //  setSparePartsData(selectedSpareparts);
              selectedSpareparts?.map((parts: any) => {
                setSparePartsData((prevData: any) => [
                  ...(Array.isArray(prevData) ? prevData : []), // Spread the existing array
                  parts,
                ]);
              });
            }}
          />

          <CreateCheckListsModal
            _ref={createCheckListModalRef}
            facility={facilityWatch}
            subFacility={subFacilityWatch}
            deletedCheckList={deletedCheckList}
            onContinue={(selectedCheckList: any[]) => {
              console.log("Selected Cehck List", selectedCheckList);
              let arrcheck: any = [];
              if (CheckList.length > 0) {
                CheckList.map((checklist: any, index: number) => {
                  arrcheck.push(checklist);
                });
              }
              if (selectedCheckList.length > 0) {
                selectedCheckList.map((checklist: any, index: number) => {
                  arrcheck.push(checklist);
                });
              }
              setCheckList(arrcheck);
              createCheckListModalRef?.current?.close();
            }}
          />

          <CreateAssetsModal
            _ref={createAssetModalRef}
            facility={facilityWatch}
            subFacility={subFacilityWatch}
            onContinue={(selectedAssets: any[]) => {
              console.log("Selected Assets", selectedAssets);
              //setValue("assets", selectedAssets);

              selectedAssets?.map((assets: any) => {
                setRowData((prevData: any) => {
                  // Check if prevData is an array, or initialize as an empty array
                  const updatedData = Array.isArray(prevData) ? [...prevData] : [];
                  // Debugging log to check the prevData and the assets being checked
                  console.log("prevData", prevData);
                  console.log("Checking assetCode for:", assets.assetID);

                  // Check if the assetCode of the current asset is not in the existing rowData
                  const assetExists = updatedData.some((item: any) => item.assetID === assets.assetID);
                  console.log("Asset exists:", assetExists);

                  // If the assetCode is not found, add the new asset
                  if (!assetExists) {
                    updatedData.push(assets);
                  }
                  // Return the updatedData
                  return updatedData;
                });
              });
              getChecklists(selectedAssets);
              // setSelectedAssets(selectedAssets);
              //setRowData(selectedAssets);
              createAssetModalRef?.current?.close();
            }}
          />

          <Controller
            name="assetImage"
            control={control}
            render={({ field: { value, onChange } }) => (
              <FileUpload
                label="Upload Picture"
                value={value}
                isMulti={true}
                accept=".jpg, .jpeg, .png"
                isFigmaType={true}
                allowedExt={[`png`, `jpg`, `jpeg`, `gif`]}
                retainFiles={true}
                onChange={(e: any, files: any) => {
                  changeAttachmentHandler(e);
                  onChange(e.target.files[0]);
                }}
                placeholder="Choose Processing Facility"
              />
            )}
          />
          {attachmentList && attachmentList.length > 0 && (
            <div>
              <h4 className="font-semibold text-[0.938rem] pb-4 uppercase">Files</h4>
              <div className="grid grid-cols-5 gap-3">
                {attachmentList.map((item: any, index: number) => {
                  const found = imgExt.some((word) => item.originalFileName.includes(word));
                  return (
                    <div key={`attachmentList${index}`} className="border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative">
                      <Link to={item.fullFilePath} target="_blank">
                        {found ? (
                          <img src={item.fullFilePath} alt={item.originalFileName} className="max-w-full max-h-20" />
                        ) : (
                          item.originalFileName
                        )}
                      </Link>
                      {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200">
          <Button type="button" theme="secondary" onClick={() => {
            formReset();
            reset_re_render_vars();
            onCancel();
          }}>
            Cancel
          </Button>
          {/* disabled={selectedAssets.length == 0 ? true : false} */}
          <Button type="submit">Save</Button>
        </div>
      </form>
    </div>
  );
};

export default CreateWorkOrder;
